import { render } from "./CartItemBig.vue?vue&type=template&id=aee532dc&scoped=true"
import script from "./CartItemBig.vue?vue&type=script&lang=js"
export * from "./CartItemBig.vue?vue&type=script&lang=js"

import "./CartItemBig.vue?vue&type=style&index=0&id=aee532dc&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aee532dc"]])

export default __exports__